const calculateVisiblePage = (
  event: React.BaseSyntheticEvent,
  pageElements: (HTMLElement | null)[],
  paddingTop: number
): number | null => {
  const parentContainer = event.target
  let actualCurrentPage = null
  let maxVisibleHeight = 0

  pageElements.forEach((element, index) => {
    if (!element) return
    const elementHeight = element.offsetHeight
    const startOfElement = element.offsetTop
    const endOfElement = startOfElement + elementHeight

    const parentContainerHeight = parentContainer.offsetHeight - paddingTop
    const parentContainerStart = parentContainer.scrollTop + paddingTop
    const parentContainerEnd = parentContainerStart + parentContainerHeight

    const isVisible = parentContainerStart < endOfElement && parentContainerEnd > startOfElement

    let visibleHeight = 0

    if (isVisible) {
      if (parentContainerStart <= startOfElement) {
        if (parentContainerEnd > endOfElement) {
          visibleHeight = elementHeight
        } else {
          visibleHeight = parentContainerEnd - startOfElement
        }
      } else {
        let missingHeight = parentContainerStart - startOfElement
        if (parentContainerEnd < endOfElement) {
          missingHeight += endOfElement - parentContainerEnd
        }

        visibleHeight = elementHeight - missingHeight
      }
    }

    if (visibleHeight > maxVisibleHeight) {
      maxVisibleHeight = visibleHeight
      actualCurrentPage = index + 1
    }
  })

  return actualCurrentPage
}

export { calculateVisiblePage }
